$(document).ready(function () {

    const totalSteps = $('.step').length;
    $('.btn-next').on('click', function () {
        let currentStep = $('.step-status.active').last().data('step');
        let nextStep = currentStep + 1;

        if (nextStep <= totalSteps) {
            updateStepStatus(nextStep);
            showCurrentStep(nextStep);
            updateFooterButtons(nextStep, totalSteps);
        }
    });

    $('.btn-prev').on('click', function () {
        let currentStep = $('.step-status.active').last().data('step');
        let prevStep = currentStep - 1;

        if (prevStep >= 1) {
            updateStepStatus(prevStep);
            showCurrentStep(prevStep);
            updateFooterButtons(prevStep, totalSteps);
        }
    });

    function updateStepStatus(step) {
        $('.step-status').removeClass('active'); // Reset all step-status
        $('.step-status').filter(`[data-step="${step}"]`).addClass('active');
    }

    function showCurrentStep(step) {
        $('.step').hide();
        $(`.step[data-step="${step}"]`).show();
    }

    function updateFooterWrapperClass(step) {
        const wrapper = $('.footer-buttons-wrapper');
        wrapper.removeClass(function (index, className) {
            return (className.match(/(^|\s)step-\S+/g) || []).join(' ');
        });
        wrapper.addClass(`step-${step}`);
    }

    function updateFooterButtons(step, totalSteps) {
        $('.footer-buttons-wrapper button').hide();

        if (step > 1) {
            $('.btn-prev').show();
        }
        if (step < totalSteps) {
            $('.btn-next').show();
        }
        if (step === totalSteps) {
            $('.btn-apply').show();
        }

        updateFooterWrapperClass(step);
    }

    // Initialize first step properly
    updateStepStatus(1);
    showCurrentStep(1);
    updateFooterButtons(1, totalSteps);


    // Step 2:

    // Function to update the monogram input

    let inputSource = "typing";

    function updateMonogramInput() {
        let monogramChars = $(".preview-area .char-container .char").map(function () {
            return $(this).text();
        }).get().join('');

        $('[id^="monogram-input-"]').val(monogramChars);
    }


    $(".char-input").on("input", function () {

        inputSource = "typing";
        let index = $(this).closest(".char-inputs").index();

        $(this).removeClass('symbol');
        $(".preview-area .char-container .char").eq(index).removeClass('symbol');
        
        if ($(this).val().length > 1) {
            $(this).val($(this).val().slice(0, 1));
        }

        let charValue = $(this).val().toUpperCase();

        $(".preview-area .char-container .char").eq(index).text(charValue);
        updateMonogramInput();

        if (charValue.length === 1) {
            let nextInput = $(".char-input").eq(index + 1);
            if (nextInput.length) {
                nextInput.focus();
            }
        }
        console.log(inputSource);
    });

    $(".char-input").on("keydown", function (e) {
        if (e.key === "Backspace" && $(this).val().length === 0) {
            let index = $(this).closest(".char-inputs").index();
            $(".preview-area .char-container .char").eq(index).text("");

            updateMonogramInput();
            if (index > 0) {
                $(".char-input").eq(index - 1).focus();
            }

            $(this).removeClass('symbol');
        }
    });

    $(".char-symbol").on("click", function (e) {
        e.preventDefault();
        // Find the current focused or next empty input
        inputSource = "symbol";

        let $currentInput = $(".char-input .focused");
        
        if ($currentInput.length === 0) {
            $currentInput = $(".char-input").filter(function () {
                return $(this).val() === "";
            }).first();
        }

        if ($currentInput.length === 0) {
            $currentInput = $(".char-input").last();
        }

        let symbolValue = $(this).data('value');

        // Update the corresponding span
        let index = $currentInput.closest(".char-inputs").index();
        $(".preview-area .char-container .char").eq(index).addClass("symbol");
        $(".preview-area .char-container .char").eq(index).text(symbolValue);

        $currentInput.val(symbolValue);


        // Remove focused class from all inputs and add to current
        $(".char-input").removeClass("focused");
        $currentInput.addClass("symbol");
        $currentInput.addClass("focused");

        updateMonogramInput();

        // Move focus to next input
        let nextInput = $(".char-input").eq(index + 1);
        if (nextInput.length) {
            nextInput.focus();
        }

        console.log(inputSource);
    });

    // Step 3
    $('input[name="font_color"]').on('change', function () {
        let selectedColor = $(this).val();

        $('.preview-area').css('color', selectedColor);

        let colorName = $(this).data('color');
        $(".choose-color").text(`Choose Color: ${colorName} `);
    });

    $('input[name="font_color"]:checked').trigger('change');

});